import { Component, OnInit, SecurityContext } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import {AccountingService} from './accounting.service';
import { AppMainComponent } from "../../../app.main.component";
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { AppMainService } from '../../../app-main.service';
import { Severity } from '../constants/integration.constant';
import { TitleCasePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { AccountUserService } from 'src/app/service/account.service';
import { IOrganizationSettings, IQbWarehouseMapping } from '../../models/organization-settings.model';
import { Status } from '../../crm/constants/constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-accounting',
  templateUrl: './accounting.component.html',
  styleUrls: ['./accounting.component.scss']
})
export class AccountingComponent {

  products = [
    {
      "id":1,
      "name":"intuit quickbooks desktop",
      "img":"quickbooks.png",
      "description":"Quickbooks desktop",
      "type":"desktop",
      "installed":false,
      "showSpin":false,
      "showDetailBtn":false,
      "data": {},
    },
    {
      "id":2,
      "name":"intuit quickbooks online",
      "img":"quickbooks_online.png",
      "description":"Quickbooks online",
      "type":"online",
      "installed":false,
      "showSpin":false,
      "showDetailBtn":false,
      "data": {},
    }
  ];
  qbData_desktop = [];
  qbData_single = [
    {
      "id":1,
      "location":"AMD-Ahmedalad",
      "warehouse":"default",
      "isActive":true,
    }
  ]
  mappingData=[];
  dataView = true;
  selectedData = '';
  showMultiple = false;
  displayMoreInfo = false;
  fullInfo;

  addEditSingleDataHeader;
  addEditDesktopDataHeader;
  displayAddEditSingleData = false;
  displayAddEditDesktopData = false;
  displayMoreData = false;
  displayEditMapping = false;
  qbSingleTemp = {
    "id":0,
    "location":"",
    "isActive":false,
  };
  desktopDataTemp = {
    "id":0,
    "location":"",
    "warehouse":"",
    "isActive":false,
  }
  allLocations = [
    {id:1,name:"Lac01 - Ahamedad"},
    {id:2,name:"Lac02 - Princeton"},
  ];
  selectedLocation = [];
  allDirections = [
    {id:1,name:"LionO to QB"},
    {id:2,name:"QB to LionO"},
    {id:3,name:"Bi-direction"},
  ];
  selectedDirection;
  mappingTemp = {
    "id":0,
    "name":"",
    "sync":"",
    "isActive":false,
  };
  allWarehouses = [
    {id:1,name:"Warehouse 1"},
    {id:2,name:"Warehouse 2"},
  ];
  selectedWarehouse = [];
  warehouseCount = [];
  selectedCount;
  savedCount = [
    {id:1,value:1},
  ];
  agreed: boolean = false;
  displayQBMode = false;

  //mapping
  displayFieldMapping = false;
  lionOFields = [
    {
      id:1,
      name:"Account Information",
      fields:[
        {id:1,name:"First Name",ischecked:true,movable:true},
        {id:2,name:"Last Name",ischecked:true,movable:true},
        {id:3,name:"Account Name",ischecked:true,movable:true},
        {id:4,name:"Account Number",ischecked:true,movable:true},
        {id:5,name:"Email",ischecked:true,movable:false},
        {id:6,name:"Phone",ischecked:true,movable:false},
      ]
    },
    {
      id:2,
      name:"Account Details",
      fields:[
        {id:1,name:"Doing Business as (DBA)",ischecked:true,movable:false},
        {id:2,name:"Tax ID (EIN)",ischecked:true,movable:false},
        {id:3,name:"Number of Employees",ischecked:true,movable:false},
        {id:4,name:"Estimated Annual Revenue",ischecked:true,movable:false},
        {id:5,name:"Ownership Type",ischecked:true,movable:false},
        {id:6,name:"Account Category",ischecked:true,movable:false},
        {id:7,name:"Founded Year",ischecked:true,movable:false},
      ]
    },
  ]
  QBFields = [
    {id:1,name:"First Name",ischecked:true},
    {id:2,name:"Last Name",ischecked:true},
    {id:3,name:"Company Name",ischecked:true},
    {id:4,name:"Account Number",ischecked:true},
    {id:5,name:"Email",ischecked:true},
    {id:6,name:"Phone",ischecked:true},
    {id:1,name:"Doing Business as (DBA)",ischecked:true},
    {id:2,name:"Tax ID (EIN)",ischecked:true},
    {id:3,name:"Number of Employees",ischecked:true},
    {id:4,name:"Estimated Annual Revenue",ischecked:true},
    {id:5,name:"Ownership Type",ischecked:true},
    {id:6,name:"Account Category",ischecked:true},
    {id:7,name:"Founded Year",ischecked:true},
  ];
  selectedSectionHeader = [];

  tempConnection = {
    "id":0,
    "clientID":"",
    "token":""
  }
  displayConnection = false;
  displaySchedule = false;
  ScheduleOptions: string;
  displayTerms = false;
  isMultiple = true;
  qbIntegrationTypes=[];
  warehouseDirectionIntegrationTypes=[];
  warehouseList=[];
  QBWarehouseList=[];
  qbDesktopDetails;
  schedularForm: FormGroup;
  connectForm: FormGroup;
  warehouseForm: FormGroup;
  fieldMappingForm: FormGroup;
  vendor;
  windowRef = null;
  isQBOnlineConnected = false;
  vendorAuthRegistrationUser;
  defaultWarehouse;
  qbOnlineIntegration;
  singleWarehouse;
  assestBaseUrl: string = environment.assestsBasePath;


  constructor(private confirmationService: ConfirmationService,private messageService: MessageService,
    private integratonService: AccountingService,private app: AppMainComponent,private fb: FormBuilder,
    private appMainService: AppMainService,
    private titlecasePipe: TitleCasePipe,
    private sanitizer: DomSanitizer,
    private accountService: AccountUserService) { }

  ngOnInit() {
    this.qbData_desktop = JSON.parse(JSON.stringify(this.qbData_single));
    this.loadIntegrationGroups();
    this.loadWarehouseList();
    this.loadQBWarehouseList();
    this.getQBOnlineInstallStatusByVendor();
    this.schedularForm = this.fb.group({
      schedule: [null]
    });

    this.connectForm = this.fb.group({
      clientId: [null],
      authToken: [null]
    });

    this.warehouseForm = this.fb.group({
      id: [0],
      createdSource: [''],
      updatedSource: [''],
      createdBy: [null],
      updatedBy: [null],
      createdDate: [null],
      updatedDate: [null],
      organizationId: [null],
      warehouseId: [null],
      qbWarehouseId: [null],
      statusId: [null],
      qbOrganizationSettingsId: [null],
      warehouseName: [''],
      qbWarehouseName: ['']
    });

    this.fieldMappingForm = this.fb.group({
      id: [0],
      objectData: [null],
      createdSource: [''],
      updatedSource: [''],
      createdBy: [null],
      updatedBy: [null],
      createdDate: [null],
      updatedDate: [null],
      organizationId: [null],
      objectId: [null],
      columnMappingJSON: [null],
      syncFromTypeId: [null],
      integrationTypeId:[null],
      statusId: [null]
    });
    // this.src = this.sanitizer.bypassSecurityTrustResourceUrl("https://appcenter.intuit.com/connect/oauth2?client_id=ABM6UICKt6vXTB9pFf3YYMqPQrJDgAV4fNSSwkzm1y4uR3N1Aq&response_type=code&scope=com.intuit.quickbooks.accounting&redirect_uri=http%3A%2F%2Fdevapp01.lionodev.com%2FLiono360applicationThirdPartyIntegrationapi%2FLionO360%2F2.0%2FAPI%2FAuthentication%2FAccessToken&state=1");
  }

  loadWarehouseList(){
    this.integratonService.getAllWarehouse().subscribe(warehouse=>{
      this.warehouseList= warehouse?.filter(warehouse=> warehouse.statusId==1);
      this.defaultWarehouse = this.warehouseList?.find(w => w.isDefault == true);
    })
  }

  loadQBWarehouseList(){
    this.integratonService.getAllQBWarehouse().subscribe(warehouse=>{
      this.QBWarehouseList= warehouse;
    })
  }

  loadIntegrationGroups(){
    this.appMainService.isShowSpinner("qb");
    this.integratonService.getIntegrationGroups().subscribe(groups=>{
      const integrationGroups= groups;
      // console.log(integrationGroups)
      const integrationType = integrationGroups?.filter(grp=> grp.name=='IntegrationType')[0];
      this.loadIntegrationsTypes(integrationType?.id,'integrationType');
      const warehouseIntegrationType = integrationGroups.filter(grp=> grp.name=='WarehouseIntegrationType')[0];
      this.loadIntegrationsTypes(warehouseIntegrationType?.id,'warehouseIntegrationType');
      const syncType = integrationGroups?.filter(grp=> grp.name=='SyncType')[0];
      this.loadIntegrationsTypes(syncType?.id,'syncType');
    })
  }

  loadIntegrationsTypes(groupId,type){
    this.integratonService.getIntegrationTypes(groupId).subscribe(types=>{
      if(type=='integrationType'){
       this.qbIntegrationTypes=types;
       const qbDesktopIntegration = this.qbIntegrationTypes?.filter(int=> int.name=='QB Desktop')[0];
       this.qbOnlineIntegration = this.qbIntegrationTypes?.find(i => i?.name.toLowerCase() =='qb online');
       this.loadQBDesktopIntegrationDetails(qbDesktopIntegration?.id);
      }else if(type=='warehouseIntegrationType'){
       this.warehouseDirectionIntegrationTypes=types;
       this.singleWarehouse = types?.find(t => t?.name?.toLowerCase() == "single warehouse");
      }else if(type=='syncType'){
       this.allDirections=types;
      //  console.log(this.allDirections)
      }
    })
  }

  loadQBDesktopIntegrationDetails(typeId){
    this.integratonService.getAllIntegrationDetails(typeId).subscribe(details=>{
      // console.log(details)
      if(details?.length>0){
        if(details[0].isTermsAgreed){
          this.qbDesktopDetails=details[0];
          this.products[0].showSpin=false;
          this.products[0].showDetailBtn=true;
          this.products[0].installed=true;
          this.appMainService.isHideSpinner("qb");
        }
      }else{
        this.appMainService.isHideSpinner("qb");
      }
    })
  }

  showMoreInfo(c){
    this.fullInfo = JSON.parse(JSON.stringify(c));
    this.displayMoreInfo = true;
  }
  changeTableView(c){
    if(c.type == 'online' && c.data && c.data?.id){
      this.getUserByVendorAuthRegistrationId(c.data?.id || 0);
    }
    this.selectedData = c.type;
    this.dataView = false;
  }

  backDataView(){
    this.dataView = true;
    this.ScheduleOptions = null;
  }

  addSingleData(){
    this.addEditSingleDataHeader = "Warehouse Mapping";
    this.qbSingleTemp = {
      "id":0,
      "location":"",
      "isActive":false,
    };
    this.displayAddEditSingleData = true;
  }
  editSingleData(c){
    this.addEditSingleDataHeader = "Warehouse Mapping";
    this.qbSingleTemp = JSON.parse(JSON.stringify(c));
    this.displayAddEditSingleData = true;
  }
  addDesktopData(){
    this.addEditDesktopDataHeader = "Warehouse Mapping";
    this.desktopDataTemp = {
      "id":0,
      "location":"",
      "warehouse":"",
      "isActive":false,
    };
    this.displayAddEditDesktopData = true;
  }

  editMultipleData(c){
    this.addEditDesktopDataHeader = "Warehouse Mapping";
    this.warehouseForm.patchValue(c)
    const filteredWarehouse = this.warehouseList.filter((warehouse: any)=> warehouse.id==c.warehouseId)[0];
    this.warehouseForm.controls['warehouseId'].setValue(filteredWarehouse);
    if(this.qbDesktopDetails?.warehouseIntegrationType=='Multi Warehouse'){
      const filteredQBWarehouse = this.QBWarehouseList.filter((warehouse: any)=> warehouse.id==c.qbWarehouseId)[0];
      this.warehouseForm.controls['qbWarehouseId'].setValue(filteredQBWarehouse);
    }else{
      this.warehouseForm.controls['qbWarehouseName'].setValue(c?.qbWarehouseName);
      // console.log(this.warehouseForm.controls['qbWarehouseName'].value)
    }
    this.displayAddEditDesktopData = true;
  }

  saveWarehouseData(value){
  //  console.log(value)
   const updatedValue = JSON.parse(JSON.stringify(value));
   value.updatedBy = this.app.userId;
   value.updated= new Date().toISOString();
   value.updatedSource= this.app.userIP;
   value.warehouseId = updatedValue.warehouseId?.id;
   value.warehouseName = updatedValue.warehouseId?.name;
   value.qbWarehouseId = updatedValue.qbWarehouseId?.id;
   value.qbWarehouseName = updatedValue.qbWarehouseId?.name;
  //  console.log(value)
   this.integratonService.updateWarehousMappingeData(value).then(() => {
    const qbDesktopIntegration = this.qbIntegrationTypes.filter((int: any)=> int.name=='QB Desktop')[0];
    this.loadQBDesktopIntegrationDetails(qbDesktopIntegration?.id);
    this.displayAddEditDesktopData=false;
      this.messageService.add({severity: 'success',summary: 'Success',
          detail: "QB Desktop warehouse  mapping data updated successfully..."});
  })
  .catch(() => {
      this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: "Error occurred while saving...",
      });
  });
  }

  showMappingData(){
    this.appMainService.isShowSpinner('mapping');
    this.integratonService.getAllMappingData().subscribe(mapping=>{
      this.mappingData = mapping;
      this.displayMoreData = true;
      this.appMainService.isHideSpinner('mapping');
    })
  }

  editMapping(c){
    // console.log(c)
    this.fieldMappingForm.patchValue(c);
    const filetredSyncType = this.allDirections.filter(type=> type.id==c.syncFromTypeId)[0];
    this.fieldMappingForm.controls['syncFromTypeId'].setValue(filetredSyncType);
    this.fieldMappingForm.controls['statusId'].setValue(c.statusId==1?true:false);
    this.displayEditMapping = true;
  }

  updateSyncData(value){
    const syncUpdatedData = JSON.parse(JSON.stringify(value));
    value.updatedBy= this.app.userId;
    value.updatedDate= new Date().toISOString();
    value.updatedSource= this.app.userIP;
    value.syncFromTypeId = syncUpdatedData.syncFromTypeId?.id;
    value.syncType = syncUpdatedData.syncFromTypeId?.name;
    value.statusId = (value.statusId?1:2);
    const selectedObj = this.mappingData.filter(data=> data.id==value.id)[0];
    const index = this.mappingData.indexOf(selectedObj);
    this.mappingData.splice(index, 1);
    this.mappingData.splice(index,0,value);
    // console.log(this.mappingData)
    this.displayEditMapping=false;
  }

  updateMappingData(){
    this.integratonService.updateMappingeData(this.mappingData).then(() => {
      this.displayMoreData=false;
      this.messageService.add({severity: 'success',summary: 'Success',
            detail: "QB Desktop mapping data updated successfully..."});
    })
    .catch(() => {
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: "Error occurred while saving...",
        });
    });
  }

  confirmMapping(){
    this.lionOFields.map((obj, index) =>{
      this.syncHeaderCheckBox(index);
    })
    this.displayFieldMapping = true;
  }
  selectSectionHeader(checkValue, index) {
    if (checkValue.checked) {
      for (let s of this.lionOFields[index].fields) {
        s.ischecked = true;
      }
    } else if(!checkValue.checked) {
      for (let s of this.lionOFields[index].fields) {
        if (s.movable) {
          s.ischecked = true;
        } else {
          s.ischecked = false;
        }
      }
    }
  }
  syncHeaderCheckBox(index){
    const sectionFields = this.lionOFields[index]
    const unChecedFieldExists = sectionFields.fields.find(obj => obj.ischecked == false);
    this.selectedSectionHeader[index] = unChecedFieldExists ? false: true;
  }

  editConnect(){
    this.connectForm.patchValue(this.qbDesktopDetails)
    this.displayConnection = true;
  }

  copyInputMessage(inputElement){
    inputElement.disabled = false;
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    inputElement.disabled = true;
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Copied successfully' });
  }

  editSchedule(){
    this.schedularForm = this.fb.group({
      schedule: [(this.qbDesktopDetails?.isScheduled && this.qbDesktopDetails?.pausedOn==null)?'Resume':(this.qbDesktopDetails?.isScheduled && this.qbDesktopDetails?.pausedOn!=null)?'Pause':null]
    });
    this.displaySchedule = true;
  }

  setSchedular(value){
    // console.log(value)
    if(value.schedule=='Pause'){
      this.qbDesktopDetails.pausedOn = new Date().toISOString();
      this.qbDesktopDetails.isScheduled=true;
      this.updateSchedularDesktop(this.qbDesktopDetails);
    }else{
      this.qbDesktopDetails.pausedOn = null;
      this.qbDesktopDetails.isScheduled=true;
      this.updateSchedularDesktop(this.qbDesktopDetails);
    }
    this.displaySchedule = false;
  }

  openSetup(){
    this.displayTerms = true;
    this.warehouseCount = Array.from({length: 8}, (_, i) => i + 2);
  }

  saveSetup(){
    if(this.selectedCount){
      this.savedCount = [];
      for(let i=0; i<this.selectedCount; i++){
        let eachCount = {
          id:i+1,
          value:i+1
        }
        this.savedCount.push(eachCount);
      }
    }
    this.displayTerms = false;
    this.showMultiple = true;
  }

  saveSetup2(){
    if(this.isMultiple){
      this.showMultiple = true;
    } else {
      this.showMultiple = false;
    }
    this.displayQBMode = false;
  }

  confirm(data) {
    this.confirmationService.confirm({
        message: "Are you sure that you want to proceed?",
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        rejectLabel: "Cancel",
        accept: () => {
            data.isActive = !data.isActive;
        },
    });
  }
  confirm2() {
    this.confirmationService.confirm({
        message: "Are you sure that you want to proceed?",
        header: "Confirmation",
        icon: "pi pi-exclamation-triangle",
        rejectLabel: "Cancel",
        accept: () => {
           this.isMultiple = !this.isMultiple;
        },
    });
  }

  editQBMode(){
    this.displayQBMode = true;
  }

  installBtn(c){
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        c.showSpin = true;
        if(c?.type == 'online'){
          this.installQBOnline(c);
          this.saveQBOnlineOrganizationSettings();
        }else {
          this.installQBDesktop(c);
        }
      }
    });
  }

  installQBDesktop(c){
    const req={
      id: 0,
      createdSource: this.app.userIP,
      updatedSource: this.app.userIP,
      createdBy: this.app.userId,
      updatedBy: this.app.userId,
      createdDate: new Date().toISOString(),
      updatedDate: new Date().toISOString(),
      organizationId: this.app.companyId,
      clientId: '',
      authToken: '',
      syncStartDate: new Date().toISOString(),
      discountItemCode: '',
      taxItemCode: '',
      shippingItemCode: '',
      isScheduled: false,
      pausedOn: null,
      locationCount: 0,
      isTermsAgreed: true,
      statusId: 1,
      integrationTypeId: this.qbIntegrationTypes.filter(type=> type.name=='QB Desktop').map(t=> t.id)[0],
      warehouseIntegrationTypeId: this.warehouseDirectionIntegrationTypes.filter(type=> type.name=='Single Warehouse').map(t=> t.id)[0],
      qbWarehouseMapping: [
        {
          id: 0,
          createdSource: this.app.userIP,
          updatedSource: this.app.userIP,
          createdBy: this.app.userId,
          updatedBy: this.app.userId,
          createdDate: new Date().toISOString(),
          updatedDate: new Date().toISOString(),
          organizationId: this.app.companyId,
          warehouseId: this.warehouseList.filter((w: any)=> w.isDefault==true).map((location: any)=> location.id)[0],
          qbWarehouseId: '',
          statusId: 1,
          qbOrganizationSettingsId: 0
        }
      ]
    }
    // console.log(req)
    this.integratonService.installQB(req)
                    .then(() => {
                      c.showSpin = false;
                      const qbDesktopIntegration = this.qbIntegrationTypes.filter(int=> int.name=='QB Desktop')[0];
                      this.loadQBDesktopIntegrationDetails(qbDesktopIntegration?.id);
                        this.messageService.add({severity: 'success',summary: 'Succes',
                            detail: "QB Desktop Installation completed successfully..."});
                    })
                    .catch(() => {
                      c.installed = false;
                      c.showSpin = false;
                      c.showDetailBtn = false;
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: "Error occurred while installation...",
                        });
                    });
  }

  getQBOnlineInstallStatusByVendor(){
    this.appMainService.isShowSpinner("loadQBOnlineInstallStatus");
    this.integratonService.getQBOnlineInstallStatus("QBOnline")
    .subscribe({
        next: (res) => {
            if(res && res.id){
              this.products?.forEach(e => {
                if(e.type == 'online'){
                  e.installed = true;
                  e.showSpin = false;
                  e.showDetailBtn = true;
                  e.data = res;
                }
              });
              this.vendor = res;
            }
            this.appMainService.isHideSpinner("loadQBOnlineInstallStatus");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("loadQBOnlineInstallStatus");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }

  getUserByVendorAuthRegistrationId(id){
    this.appMainService.isShowSpinner("loadQBOnlineInstallStatus");
    this.integratonService.getUserByVendorAuthRegistrationId(id)
    .subscribe({
        next: (res) => {
            if(res && res.refreshToken && res.accessToken){
              this.vendorAuthRegistrationUser = res;
              this.isQBOnlineConnected = true;
            }
            this.appMainService.isHideSpinner("loadQBOnlineInstallStatus");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("loadQBOnlineInstallStatus");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }

  installQBOnline(c){
    this.appMainService.isShowSpinner("installQBOnline");
    this.integratonService.getAllVendorRegistration()
    .subscribe({
        next: (res) => {
            let vendor = res?.find(v => v?.organizationId == this.app.companyId || v?.organizationId == 0);
            if(vendor){
              vendor.id = 0;
              vendor.organizationId = this.app.companyId;
              vendor.createdBy = this.app.userId;
              this.saveVendorRegistration(vendor, c);
            }
            this.appMainService.isHideSpinner("installQBOnline");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("installQBOnline");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }

  saveQBOnlineOrganizationSettings(){
    let qbWarehouseMappings: IQbWarehouseMapping[] = [];
    let qbWarehouseMapping: IQbWarehouseMapping = {
      id: 0,
      createdSource: this.app.userIP,
      updatedSource: this.app.userIP,
      createdBy: this.app.user.userId,
      updatedBy: this.app.user.userId,
      createdDate: this.app._saveDateTimeWithZone(new Date()),
      updatedDate: this.app._saveDateTimeWithZone(new Date()),
      organizationId: this.app.companyId,
      warehouseId: this.defaultWarehouse?.id || 0,
      qbWarehouseId: "",
      statusId: Status.ACTIVE,
      qbOrganizationSettingsId: 0
    }
    qbWarehouseMappings.push(qbWarehouseMapping);

    let organizationSettings : IOrganizationSettings = {
      id: 0,
      createdSource: this.app.userIP,
      updatedSource: this.app.userIP,
      createdBy: this.app.user.userId,
      updatedBy: this.app.user.userId,
      createdDate: this.app._saveDateTimeWithZone(new Date()),
      updatedDate: this.app._saveDateTimeWithZone(new Date()),
      organizationId: this.app.companyId,
      clientId: "",
      authToken: "",
      syncStartDate: this.app._saveDateTimeWithZone(new Date()),
      discountItemCode: "",
      taxItemCode: "",
      shippingItemCode: "",
      isScheduled: false,
      pausedOn: null,
      locationCount: 0,
      isTermsAgreed: true,
      statusId: Status.ACTIVE,
      integrationTypeId: this.qbOnlineIntegration?.id || 0,
      warehouseIntegrationTypeId: this.singleWarehouse?.id || 0,
      qbWarehouseMapping: qbWarehouseMappings
    }

    this.appMainService.isShowSpinner("saveQBOnlineOrganizationSettings");
    this.integratonService.saveQBOnlineOrganizationSettings(organizationSettings)
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("saveQBOnlineOrganizationSettings");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("saveQBOnlineOrganizationSettings");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }

  saveVendorRegistration(vendor, c){
    this.appMainService.isShowSpinner("saveVendorRegistration");
    this.integratonService.saveVendorRegistration(vendor)
    .subscribe({
        next: (res) => {
            c.installed = true;
            c.showSpin = false;
            c.showDetailBtn = true;
            this.vendor = res;
            this.appMainService.isHideSpinner("saveVendorRegistration");
        },
        error: (error) => {
            c.installed = false;
            c.showSpin = false;
            c.showDetailBtn = false;
            this.appMainService.isHideSpinner("saveVendorRegistration");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }

  onClickQBOnlineConnectBtn(){
    console.log('this.vendor = res;', this.vendor);
    console.log('this.vendor = res;', this.vendor.redirectURL);
    let isSandbox = !this.vendor?.isProduction;
    const loggedinUser = this.accountService.userValue;
    let codeObj = {
        organizationId: this.app.companyId,
        userId: this.app.userId,
        vendorId: this.vendor?.vendorId || 0,
        clientIP: this.app.userIP,
        loginAuditId: loggedinUser.loginAuditId,
        authToken: loggedinUser.token,
        sessionId: localStorage.getItem("randomstr"),
        sourceType: "qbonline",
        accesstoken: "",
        isSandbox: isSandbox,
    }

    this.appMainService.isShowSpinner("authenticate");
    this.integratonService.authenticateQBOnline(btoa(JSON.stringify(codeObj)), isSandbox, this.vendor?.redirectURL)
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("authenticate");
            this.windowRef = window.open(
              res,
              "child",
              "toolbar=no,location=no,directories=no,status=no,menubar=no,titlebar=no,fullscreen=no,scrollbars=1,resizable=no,width=1000,height=650,left=200,top=100"
            );
            let windowRefInterval = setInterval(() => {
              const href = this.windowRef.location.href;
              if (href != null) {
                const queryString = this.windowRef.location.search;
                const urlParams = new URLSearchParams(queryString);
                this.saveQBOnlineAuthenticationData(urlParams);
                if (this.windowRef) {
                  this.windowRef.close();
                }
                clearInterval(windowRefInterval);
              }
          }, 3000);
        },
        error: (error) => {
            this.appMainService.isHideSpinner("authenticate");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }

  onClickQBOnlineDisconnectBtn(){
    console.log(this.vendorAuthRegistrationUser);
    this.appMainService.isShowSpinner("saveauthenticationdata");
    this.integratonService.qbOnlineDisconnect(this.vendorAuthRegistrationUser?.id ||0)
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("saveauthenticationdata");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("saveauthenticationdata");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }

  saveQBOnlineAuthenticationData(urlParams){
    this.appMainService.isShowSpinner("saveauthenticationdata");
    this.integratonService.saveQBOnlineAuthenticationData(urlParams)
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("saveauthenticationdata");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("saveauthenticationdata");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }

  uninstallBtn(c){
    if(c?.type == 'online'){
      this.confirmationService.confirm({
        message: 'Are you sure that you want to proceed?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.uninstallQBOnline(c);
        }
      });
    } else {
      this.confirmationService.confirm({
        message: 'Are you sure that you want to proceed?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
         this.appMainService.isShowSpinner("qb");
         this.integratonService.unInstallQB(this.qbDesktopDetails?.id).subscribe((res: any)=>{
          if(res){
          c.showDetailBtn=false;
          c.installed=false;
          c.showSpin=false;
          this.appMainService.isHideSpinner("qb");
          this.messageService.add({severity: 'success',summary: 'Succes',
                detail: "QB Desktop uninstallation completed successfully..."});
          }
         })
        }
      });
    }
  }

  uninstallQBOnline(c){
    this.appMainService.isShowSpinner("uninstallqbonline");
    this.integratonService.deleteVendor(c?.data?.id || 0)
    .subscribe({
        next: (res) => {
            c.showDetailBtn=false;
            c.installed=false;
            c.showSpin=false;
            this.appMainService.isHideSpinner("uninstallqbonline");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("uninstallqbonline");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }

  updateSchedularDesktop(value){
    const req={
      id: value.id,
      createdSource: value.createdSource,
      updatedSource: this.app.userIP,
      createdBy: value.createdBy,
      updatedBy: this.app.userId,
      createdDate: value.createdDate,
      updatedDate: new Date().toISOString(),
      organizationId: this.app.companyId,
      clientId: value.clientId,
      authToken: value.authToken,
      syncStartDate: value.syncStartDate,
      discountItemCode: '',
      taxItemCode: '',
      shippingItemCode: '',
      pausedOn: value.pausedOn,
      locationCount: 0,
      isTermsAgreed: true,
      isScheduled: true,
      statusId: 1,
      integrationTypeId: value.integrationTypeId,
      warehouseIntegrationTypeId: value.warehouseIntegrationTypeId,
      qbWarehouseMapping: [
        {
          id: value.qbWarehouseMapping[0].id,
          createdSource: value.qbWarehouseMapping[0].createdSource,
          updatedSource: this.app.userIP,
          createdBy: value.qbWarehouseMapping[0].createdBy,
          updatedBy: this.app.userId,
          createdDate: value.qbWarehouseMapping[0].createdDate,
          updatedDate: new Date().toISOString(),
          organizationId: this.app.companyId,
          warehouseId: value.qbWarehouseMapping[0].warehouseId,
          qbWarehouseId: '',
          statusId: 1,
          qbOrganizationSettingsId: 0
        }
      ]
    }
    this.integratonService.updateQB(value).then(() => {
      const qbDesktopIntegration = this.qbIntegrationTypes.filter(int=> int.name=='QB Desktop')[0];
      this.loadQBDesktopIntegrationDetails(qbDesktopIntegration?.id);
      this.displayConnection = false;
      this.displaySchedule=false;
        this.messageService.add({severity: 'success',summary: 'Succes',
            detail: "QB Desktop integration updated successfully..."});
    })
    .catch(() => {
        this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: "Error occurred while saving...",
        });
    });
  }

  savePaymentTerm(){
    this.appMainService.isShowSpinner("savePaymentTerm");
    this.integratonService.savePaymentTerm()
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("savePaymentTerm");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("savePaymentTerm");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }
  savePaymentMethod(){
    this.appMainService.isShowSpinner("savePaymentMethod");
    this.integratonService.savePaymentMethod()
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("savePaymentMethod");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("savePaymentMethod");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }
  saveProduct(){
    this.appMainService.isShowSpinner("saveProduct");
    this.integratonService.saveProduct()
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("saveProduct");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("saveProduct");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }
  saveInvoice(){
    this.appMainService.isShowSpinner("saveInvoice");
    this.integratonService.saveInvoice()
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("saveInvoice");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("saveInvoice");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }
  saveReceivePayment(){
    this.appMainService.isShowSpinner("saveReceivePayment");
    this.integratonService.saveReceivePayment()
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("saveReceivePayment");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("saveReceivePayment");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }

  // Add accounts to QB online
  addAccountsToQB(){
    this.appMainService.isShowSpinner("saveAccount");
    this.integratonService.addAccountsToQB()
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("saveAccount");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("saveAccount");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }
  // Add accounts to LionO
  addAccountsToLionO(){
    this.appMainService.isShowSpinner("saveAccount");
    this.integratonService.addAccountsToLionO()
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("saveAccount");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("saveAccount");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }
  // Add vendor to QB
  addVendorToQB(){
    this.appMainService.isShowSpinner("saveVendor");
    this.integratonService.addVendorToQB()
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("saveVendor");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("saveVendor");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }
  // Add vendor to LinoO
  addVendorToLionO(){
    this.appMainService.isShowSpinner("saveVendor");
    this.integratonService.addVendorToLionO()
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("saveVendor");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("saveVendor");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }
  // Add Bills to QB
  addBillsToQB(){
    this.appMainService.isShowSpinner("saveVendor");
    this.integratonService.addBillsToQB()
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("saveVendor");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("saveVendor");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }
  // Add bill payment to LinoO
  addBillPaymentToLionO(){
    this.appMainService.isShowSpinner("saveVendor");
    this.integratonService.addBillPaymentToLionO()
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("saveVendor");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("saveVendor");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }
  // Add product as service to LinoO
  addProductAsServiceToLionO(){
    this.appMainService.isShowSpinner("addProductAsServiceToLionO");
    this.integratonService.addProductAsServiceToLionO()
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("addProductAsServiceToLionO");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("addProductAsServiceToLionO");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }
  // Add product as service to LinoO
  addServiceAsProducts(){
    this.appMainService.isShowSpinner("addProductAsServiceToLionO");
    this.integratonService.addServiceAsProducts()
    .subscribe({
        next: (res) => {
            this.appMainService.isHideSpinner("addProductAsServiceToLionO");
        },
        error: (error) => {
            this.appMainService.isHideSpinner("addProductAsServiceToLionO");
            this.messageService.add({
                severity: Severity.Error,
                summary: this.titlecasePipe.transform(Severity.Error),
                detail: "Error occurred...",
            });
        }
    });
  }
}
